export default function Why() {
  const cards = [
    {
      title: '3秒で伝わらない',
      text: '誰向け・何の価値・何が解決するかが即理解できないと離脱します。'
    },
    {
      title: '問い合わせ理由が弱い',
      text: '"今すぐ連絡する理由"がないと、検討が先送りになります。'
    },
    {
      title: '決断材料が不足',
      text: '事例・数字・比較・プロセスが不足すると、最終決断できません。'
    }
  ];

  return (
    <section id="why" className="py-20 md:py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            なぜ「広告」だけでは<br className="md:hidden" />問い合わせは増えないのか
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            問い合わせは「理解 → 共感 → 信頼 → 行動」で起きます。<br />
            広告は"入口"で、決め手はサイト側の構造です。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {cards.map((card, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-lg mb-4">
                <i className="ri-close-circle-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{card.title}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
